import React from 'react';
import styled from '@emotion/styled';
import HoverDocumentCircles from './HoverDocumentCircles';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  margin-bottom: 1rem;
  max-width: 100%;
  overflow: hidden;
`;

const Title = styled.h4`
  margin: 0;
  color: #ffffff;
  font-size: 1rem;
  font-weight: 500;
`;


const EmptyState = styled.div`
  padding: 1rem;
  text-align: center;
  color: #6b7280;
  font-size: 0.9rem;
  font-style: italic;
`;


// Main component
function AvailableDocuments({ 
  documentsByType = {},
  onPreviewDocument,
  onToggleMute,
  onToggleAutoPopulate,
  autoPopulateExpanded = false,
  showAutoPopulate = true
}) {
  const hasAnyDocuments = Object.values(documentsByType).some(docs => docs.length > 0);

  return (
    <Container>
      <Title>
        Associated Documents
      </Title>
      
      
      {hasAnyDocuments ? (
        <HoverDocumentCircles
          documentsByType={documentsByType}
          onPreviewDocument={onPreviewDocument}
          onToggleMute={onToggleMute}
        />
      ) : (
        <EmptyState>
          No documents available. Upload files or use auto-populate to add documents.
        </EmptyState>
      )}
    </Container>
  );
}

export default AvailableDocuments;
